import { ReactElement } from 'react'

import ValidateAnttImpl from 'modules/user/domain/usecases/ValidateAnttImpl'
import ValidateCnpjImpl from 'modules/user/domain/usecases/ValidateCnpjImpl'
import FindTerms from 'shared/modules/termosUso/domain/usecases/Find'
import TermosUsoRepository from 'shared/modules/termosUso/infra/repositories/TermosUsoRepository'

import ValidateEmailByCodeImpl from '../../domain/usecases/ValidateEmailByCodeImpl'
import ConsultZipCodeImpl from '../../domain/usecases/ConsultZipCodeImpl'
import CreateFrotistaImpl from '../../domain/usecases/CreateFrotistaImpl'
import SendPinImpl from '../../domain/usecases/SendPinImpl'
import ValidateEmailImpl from '../../domain/usecases/ValidateEmailImpl'
import VerifyPinImpl from '../../domain/usecases/VerifyPinImpl'
import UserRepository from '../../infra/repositories/UserRepository'
import VerifyPhoneAndCnpjImpl from 'modules/user/domain/usecases/VerifyPhoneAndCnpjImpl'
import SignUp from '../../pages/SignUp'

export const SignUpFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const validateEmailImpl = new ValidateEmailImpl(userRepository)
  const validateAnttImpl = new ValidateAnttImpl(userRepository)
  const sendPinImpl = new SendPinImpl(userRepository)
  const verifyPinImpl = new VerifyPinImpl(userRepository)
  const consultZipCodeImpl = new ConsultZipCodeImpl(userRepository)
  const createFrotistaImpl = new CreateFrotistaImpl(userRepository)
  const termosUsoRepository = new TermosUsoRepository()
  const findImpl = new FindTerms(termosUsoRepository)
  const validateCnpjImpl = new ValidateCnpjImpl(userRepository)
  const verifyPhoneAndCnpjImpl = new VerifyPhoneAndCnpjImpl(userRepository)
  const validateEmailByCode = new ValidateEmailByCodeImpl(userRepository)

  return (
    <SignUp
      validateEmail={validateEmailImpl}
      validateEmailByCode={validateEmailByCode}
      sendPin={sendPinImpl}
      verifyPin={verifyPinImpl}
      consultZipCode={consultZipCodeImpl}
      createFrotistaImpl={createFrotistaImpl}
      findTerms={findImpl}
      validateAntt={validateAnttImpl}
      validateCnpjImpl={validateCnpjImpl}
      verifyPhoneAndCnpj={verifyPhoneAndCnpjImpl}
    />
  )
}
